import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { ServiceOrderComponent } from './service-order.component'

const routes: Routes = [
  {
    path: '',
    component: ServiceOrderComponent
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ServiceOrderRoutingModule {}
